module.exports = __webpack_public_path__ + "img/sld_abt.c4b36497.svg";